<template>
  <div style="display: flex; gap: 10px; align-items: center;">
    <div class="ai-box" v-show="item.scoreResult && item.scoreResult.doubleCircle" :data-title="$t('exam.iaText')">
      <p>AI</p>
      <span :class="item.scoreResult ? item.scoreResult.odStatus : ''"></span>
      <span :class="item.scoreResult ? item.scoreResult.osStatus : ''"></span>
    </div>
    <div class="ai-box" v-if="item.scoreResult && !item.scoreResult.doubleCircle" :data-title="$t('exam.iaText')">
      <p>AI </p>
      <span :class="item.scoreResult.odStatus ?? ''"></span>
    </div>
    <div class="alteration-list" v-if="item?.scoreResult?.alterationText">
      <template v-for="text in item.scoreResult.alterationText" :key="text">
        <b v-if="text === 'mcRASE2_c1'">
          {{ $t(text) }}
        </b>
        <span v-else>
          {{ $t(text) }}
        </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIScoreResult',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
